export const tails = [
  {
    value: 'long',
    text: 'Длинный',
  },
  {
    value: 'short',
    text: 'Короткий',
  },
];
